import axios from "axios";

export default axios.create({
  baseURL: "https://filesplit-python-prod.azurewebsites.net/api/",
  params: {
    code: "7AjcI54Pn9JipeznDvumksgRUnPaOEry9u9FuR5E8nc3aFKGIa8HRg==",
    clientId: "default",
  },
});
